import Cookies from 'js-cookie';

const ACCESS_TOKEN_KEY_BROKERAGE = 'control-room-b';
const REFRESH_TOKEN_KEY_BROKERAGE = 'control-room-br';

const ACCESS_TOKEN_KEY_CARRIER = 'control-room-c';
const REFRESH_TOKEN_KEY_CARRIER = 'control-room-cr';

export const getBrokerageToken = () => Cookies.get(ACCESS_TOKEN_KEY_BROKERAGE);
export const getBrokerageRefreshToken = () => Cookies.get(REFRESH_TOKEN_KEY_BROKERAGE);
export const setBrokerageTokens = (access, refresh) => {
  if (access) Cookies.set(ACCESS_TOKEN_KEY_BROKERAGE, access);
  if (refresh) Cookies.set(REFRESH_TOKEN_KEY_BROKERAGE, refresh);
};
export const clearBrokerageTokens = () => {
  Cookies.remove(ACCESS_TOKEN_KEY_BROKERAGE);
  Cookies.remove(REFRESH_TOKEN_KEY_BROKERAGE);
};

export const getCarrierToken = () => Cookies.get(ACCESS_TOKEN_KEY_CARRIER);
export const getCarrierRefreshToken = () => Cookies.get(REFRESH_TOKEN_KEY_CARRIER);
export const setCarrierTokens = (access, refresh) => {
  if (access) Cookies.set(ACCESS_TOKEN_KEY_CARRIER, access);
  if (refresh) Cookies.set(REFRESH_TOKEN_KEY_CARRIER, refresh);
};
export const clearCarrierTokens = () => {
  Cookies.remove(ACCESS_TOKEN_KEY_CARRIER);
  Cookies.remove(REFRESH_TOKEN_KEY_CARRIER);
};
